import { CHANGE_ABSENCE_FILTER } from '@/constants/ActionTypes.js';

export const changeAbsenceFilter = absenceObject => (dispatch) => {
  dispatch({
    type: CHANGE_ABSENCE_FILTER,
    payload: absenceObject,
  });
};
